import styled from 'styled-components';

export const BodyContainer = styled.div.attrs({
  className: 'BodyContainer',
})`
  width: 100%;
  height: 100%;
  background: black;
  overflow: hidden;
`;
